import { LatLngExpression } from "leaflet";
import { DataArray, IMapsLocation, InputArray } from "../services/interface/IDemand";

export const formatter = (num: number): string => {
    let isNegative = num < 0;
    num = Math.abs(num);
    let formattedValue = "";
  
    if (num === 0) {
      formattedValue = "0";
    } else if (num > 0 && num < 1) {
      formattedValue = Number(num).toFixed(2);
    } else if (num >= 1 && num < 1000) {
      formattedValue = Number(num).toFixed(1);
    } else if (num >= 1000 && num < 1000000) {
      formattedValue = Number(num / 1000).toFixed(1) + "K";
    } else if (num >= 1000000 && num < 1000000000) {
      formattedValue = Number(num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000000000) {
      formattedValue = Number(num / 1000000000).toFixed(1) + "B";
    }
    return (isNegative ? "-" : "") + formattedValue;
};

export const formatToMonthDay = (isoDate: string): string => {
  const date = new Date(isoDate);
  const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

export const isPercentageFormatter = (num: number): string => {
  // Normalize negative zero to positive zero
  const normalizedNum = Object.is(num, -0) ? 0 : num;

  // Format number to 1 decimal place
  let result = normalizedNum.toFixed(1);
  
  // Remove trailing '.0' if present
  if (result.endsWith('.0')) {
    result = result.slice(0, -2);
  }

  // Add percentage symbol
  result = result + '%';

  // Handle negative zero case
  if (result === "-0%") {
    result = "0%";
  }

  return result;
};


export const transformTitle = (title: string): string => {
    let normalizedTitle = title.toLowerCase();

    normalizedTitle = normalizedTitle.replace(/[^a-zA-Z0-9]+/g, ' ');

    let words = normalizedTitle.split(' ').filter(word => word.length > 0);

    let capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

    return capitalizedWords.join('');
};

export const formatNumber = (num: number|string|undefined) => {
    let n = num
    if (n === null) {
        return "-"
    }
    if (n) {
        return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
        return n;
    }
};

export const formatAmount = (num: number, decimal: number = 1, unit: string = '') => {
    if (num === 0) {
        return (unit + 0).trim();
    }
}

export const splitParts = (str: string) => {
    return String(str).split(/(\d+)/).map((part: string, index: number) => {
        return index % 2 === 1 ? parseInt(part, 10) : part;
    });
};

export const transformData = (inputArray: InputArray): DataArray => {
    let resultArray: any = [];
    let localResult: any = [];
    inputArray.forEach(obj => {
      const keys = Object.keys(obj);
      if(keys.length>1){
          keys.forEach(key => {
            const value = obj[key];
            localResult.push({key,value})
          });
          resultArray.push({key:"Avg of Last 8 Weeks",value:localResult});
      }else{
        const value = obj[keys[0]];
        resultArray.push({key:keys[0],value:value})
      }
    });
    return resultArray;
};  

export const convertVhToPx = (vhValue:number) => {
    return vhValue * (window.innerHeight / 100);
}

export const getCenter = (mapLocationData: IMapsLocation[]): LatLngExpression => {
    if (mapLocationData && mapLocationData.length > 0) {
        const totalLocations = mapLocationData.length;

        const sumLatitudes = mapLocationData.reduce((sum, location) => sum + (location?.Latitude || 0), 0);
        const sumLongitudes = mapLocationData.reduce((sum, location) => sum + (location?.Longitude || 0), 0);

        const avgLatitude = sumLatitudes / totalLocations;
        const avgLongitude = sumLongitudes / totalLocations;

        return [avgLatitude, avgLongitude];
    }

    return [0, 0];
};

export const getClassName = (value: number | string) => {
    // Convert the value to a number if it is a string with a percentage
    let numericValue;
    if (typeof value === 'string' && value.includes('%')) {
      numericValue = parseFloat(value);
    } else {
      numericValue = Number(value);
    }
    
    if (numericValue > 20) {
      return 'bg-[#86bc25c9] text-[#fff]';
    } else if (numericValue > 10 && numericValue <= 20) {
      return 'bg-[#86BC2566]';
    } else if (numericValue > 0 && numericValue <= 10) {
      return 'bg-[#86BC2526]';
    }
};  


// utils/debounce.ts
export function debounce<T extends (...args: any[]) => void>(func: T, delay: number) {
    let timer: ReturnType<typeof setTimeout>;
  
    return (...args: Parameters<T>) => {
      clearTimeout(timer); // Clear the current timer
      timer = setTimeout(() => {
        func(...args); // Call the function after the delay
      }, delay);
    };
  }
  
export const calculateData = (data: any, key: string) => {
    return data.map((item: any) => ({
        ...item,
        bound: [item[key] ?item[key] * 1.10 : null, item[key] ? item[key] * 0.90 : null]
    }));
}

// filter
export const formatFilterName = (filterKey: string) =>
    filterKey
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^./, (str) => str.toUpperCase());